import React from 'react';
import pt from 'prop-types';

import './live-page.scss';

/**
 * Link to a public page on the marketing site (partner profile, app listing),
 * opened in a new tab.
 */
export default function LivePageLink({ to, children = 'View live page' }) {
  return (
    <a href={to} target="_blank" rel="noreferrer" className="live-page-link">
      {children}
      <svg
        width="14"
        height="14"
        viewBox="0 0 14 14"
        fill="none"
        aria-hidden="true"
      >
        <path
          d="M5.25 2.625H2.625A1.125 1.125 0 0 0 1.5 3.75v7.625A1.125 1.125 0 0 0 2.625 12.5H10.25a1.125 1.125 0 0 0 1.125-1.125V8.75M8.5 1.5H12.5M12.5 1.5V5.5M12.5 1.5L6.25 7.75"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </a>
  );
}

LivePageLink.propTypes = {
  to: pt.string.isRequired,
  children: pt.node,
};
